import axios from 'axios';

import { CORE_API_URL } from '../utility/Constant';

export const getBookingAppointments = (userId, params) => axios.get(`${CORE_API_URL}/appointments/client_appointments?user_id=${userId}`, { params });
export const getAvailableProviders = data => axios.post(`/appointment/v1/appointments/search/providers`, data);
export const bookAppointment = data => axios.post(`${CORE_API_URL}/appointments`, data);
